<template>
	<article class="review-word-stats">
		<managing-section :column-count="2">
			<managing-box title="브랜드">
				<search-brand-initial
					ref="SearchBrandInitial"
					@change="changeBrand"
				/>
			</managing-box>
			<managing-box title="제품">
				<select
					class="select review-word-stats__product-selector"
					v-model="idProduct"
					@change="idProductChange"
				>
					<option
						v-for="item in parsedProductList"
						:key="item.id"
						:value="item.id"
						:disabled="item.id === null"
					>
						{{ item.title }}
					</option>
				</select>
			</managing-box>
		</managing-section>
		<managing-section v-if="idProduct" :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left"></div>
				<div class="section__info__right">
					<select
						class="select section__info__items"
						v-model="limit"
						@change="changeFilter('limit', $event)"
					>
						<option
							v-for="item in parsedLimitList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<select
						class="select section__info__items"
						v-model="gender"
						@change="changeFilter('gender', $event)"
					>
						<option
							v-for="item in genderList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<select
						class="select section__info__items"
						v-model="ages"
						@change="changeFilter('ages', $event)"
					>
						<option
							v-for="item in agesList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<select
						class="select section__info__items"
						v-model="skinType"
						@change="changeFilter('skinType', $event)"
					>
						<option
							v-for="item in skinTypeList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<select
						class="select section__info__items"
						v-model="rating"
						@change="changeFilter('rating', $event)"
					>
						<option
							v-for="item in ratingList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<select
						class="select section__info__items"
						v-model="isEvaluation"
						@change="changeFilter('isEvaluation', $event)"
					>
						<option
							v-for="item in isEvaluationList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<button
						class="btn-excel section__info__items"
						@click="excelDownload"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
		</managing-section>
		<managing-section
			v-for="(typeObj, idx) in parsedStatsData"
			:key="idx"
			:is-table="true"
		>
			<div slot="topBar">
				<p class="section__info__left">{{ typeObj.title }}</p>
			</div>
			<word-stats-chart :chart-data="typeObj.list" />
		</managing-section>
	</article>
</template>

<script>
	import { mapState } from 'vuex';
	import _ from 'lodash';
	import util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrandInitial from '@/components/SearchBrandInitial.vue';
	import WordStatsChart from '@/components/review/WordStatsChart.vue';

	export default {
		name: 'ReviewWordStats',
		components: {
			ManagingSection,
			ManagingBox,
			SearchBrandInitial,
			WordStatsChart,
		},
		data() {
			return {
				brandId: null,
				idInitial: 0,
				searchKeyword: '',
				productList: [],
				productListTotal: 0,
				idProduct: null,
				userTotal: 0,
				statsData: null,
				gender: null,
				ages: null,
				skinType: null,
				rating: null,
				isEvaluation: null,
				limit: null,
				limitList: [
					{ id: null, name: '갯수 전체' },
					{ id: 0, name: '갯수 0 ~ 4', values: [0, 4] },
					{ id: 5, name: '갯수 5 ~ 10', values: [5, 10] },
					{ id: 11, name: '갯수 11 ~ 20', values: [11, 20] },
					{ id: 21, name: '갯수 21 ~ 30', values: [21, 30] },
					{ id: 31, name: '갯수 31 ~ 50', values: [31, 50] },
					{ id: 51, name: '갯수 51 ~ 100', values: [51, 100] },
					{ id: 101, name: '갯수 101 ~', values: [101] },
				],
				lastApiUrl: '',
			};
		},
		computed: {
			parsedLimitList() {
				return this.userTotal <= 10
					? this.limitList
					: [
							this.limitList[0],
							...this.limitList.slice(2, this.limitList.length),
						];
			},
			parsedStatsData() {
				if (!this.statsData) return null;
				const order = {
					und: { idx: 1, title: '직접등록' },
					pos: { idx: 2, title: '긍정어' },
					neg: { idx: 3, title: '부정어' },
				};
				let totalData = [];
				const parsedStatsData = [];
				const sortCb = (a, b) => {
					if (a.value < b.value) {
						return 1;
					} else if (a.value > b.value) {
						return -1;
					} else if (a.label > b.label) {
						return 1;
					} else if (a.label < b.label) {
						return -1;
					} else {
						return 0;
					}
				};
				for (let id in this.statsData) {
					const wordList = [];
					for (let word in this.statsData[id]) {
						const cnt = this.statsData[id][word];
						if (this.cntCondition(cnt)) {
							wordList.push({
								label: `${word}(${cnt})`,
								value: cnt,
								data: word,
							});
						}
					}
					wordList.sort(sortCb);
					if (order[id]) {
						parsedStatsData[order[id].idx] = {
							title: `${order[id].title} (${wordList.length})`,
							list: wordList,
						};
					} else {
						totalData = [...totalData, ...wordList];
					}
				}
				totalData.sort(sortCb);
				parsedStatsData[0] = {
					title: `형태소 사전 (${totalData.length})`,
					list: totalData,
				};
				return parsedStatsData;
			},
			...mapState({
				genderList(state) {
					return this.addAllToList(state.filter.genderList, '성별');
				},
				agesList(state) {
					return this.addAllToList(state.filter.agesList, '연령대');
				},
				skinTypeList(state) {
					return this.addAllToList(
						state.filter.skinTypeList,
						'피부타입'
					);
				},
				ratingList(state) {
					return this.addAllToList(state.filter.ratingList, '평점');
				},
				isEvaluationList(state) {
					return this.addAllToList(
						state.filter.isEvaluationList,
						'평가단 여부'
					);
				},
			}),
			parsedProductList() {
				if (this.productList.length < 1) {
					return [{ title: '브랜드를 선택하세요', id: null }];
				}
				return this.productList.reduce(
					(acc, item) => {
						acc.push({
							title: `[${item.idProduct}] ${item.productTitle}`,
							id: item.idProduct,
						});
						return acc;
					},
					[{ id: null, title: `제품 (${this.productListTotal})` }]
				);
			},
		},
		watch: {
			'$route.query'(query) {
				this.setFilter(query);
			},
		},
		mounted() {
			this.setFilter(this.$route.query);
		},
		methods: {
			getFilterCondition() {
				const filterDataArr = [
					{ key: 'limit', name: '갯수' },
					{ key: 'gender', name: '성별' },
					{ key: 'ages', name: '연령대' },
					{ key: 'skinType', name: '피부타입' },
					{ key: 'rating', name: '평점' },
					{ key: 'isEvaluation', name: '평가단 여부' },
				];
				return filterDataArr.reduce((acc, filterData) => {
					const key = filterData.key;
					if (typeof this[key] === 'number') {
						const valueObj = this[`${key}List`].filter(
							item => item.id === this[key]
						)[0];
						acc.push(`${filterData.name}: ${valueObj.name}`);
					}
					return acc;
				}, []);
			},
			excelDownload() {
				try {
					if (!this.idProduct || this.parsedProductList.length < 2) {
						return;
					}
					const rows = [
						[`${this.getFilterCondition().join('. ')}`, () => '\n'],
						...this.parsedStatsData.reduce((acc, cur) => {
							acc.push([cur.title]);
							acc.push(['word', 'count']);
							acc.push(
								...cur.list.map(item => [item.data, item.value])
							);
							acc.push(['']);
							return acc;
						}, []),
					];
					const title = this.parsedProductList
						.find(item => item.id === this.idProduct)
						.title.split('::')[0];
					util.getCsv(
						[rows],
						[title],
						[['필터 조건']],
						`글로우픽_${title.replace(/ /g, '_')}`,
						this.lastApiUrl
					);
				} catch (err) {
					console.error(err);
					alert(
						'엑셀 파일을 다운로드하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			cntCondition(cnt) {
				const total10Less = this.userTotal <= 10;
				const limit = this.limit;
				if (total10Less && limit === null) {
					return true;
				} else if (!total10Less && limit === null) {
					return 5 <= cnt;
				} else {
					const values = this.limitList.filter(
						item => item.id === limit
					)[0].values;
					return limit === 101
						? 101 <= cnt
						: values[0] <= cnt && cnt <= values[1];
				}
			},
			addAllToList(list, name) {
				return list.reduce(
					(acc, curr) => {
						acc.push(curr);
						return acc;
					},
					[{ id: null, name: `${name} 전체` }]
				);
			},
			pushQuery() {
				const query = {
					idProduct: this.idProduct,
					brandId: this.brandId,
				};
				if (typeof this.idInitial === 'number')
					query.idInitial = this.idInitial;
				else if (this.searchKeyword)
					query.searchKeyword = this.searchKeyword;
				if (this.gender !== null) query.gender = this.gender;
				if (this.ages !== null) query.ages = this.ages;
				if (this.skinType !== null) query.skinType = this.skinType;
				if (this.rating !== null) query.rating = this.rating;
				if (this.isEvaluation !== null)
					query.isEvaluation = this.isEvaluation;
				if (this.limit !== null) query.limit = this.limit;
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			idProductChange() {
				this.pushQuery();
			},
			async changeBrand(obj) {
				try {
					this.productList = [];
					this.productListTotal = 0;
					this.brandId = null;
					if (obj.id === null) return;
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/brand/${obj.id}/products/`
					);
					this.productList = data.products;
					this.idProduct = this.productList.some(
						item => item.idProduct === this.idProduct
					)
						? this.idProduct
						: null;
					this.productListTotal = data.total;
					this.brandId = obj.id;
					this.idInitial = obj.idInitial;
					this.searchKeyword = obj.searchKeyword;
				} catch (err) {
					console.error(err);
					alert(
						'상품목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			changeFilter() {
				this.pushQuery();
			},
			async getStats() {
				try {
					this.statsData = null;
					const params = {};
					if (this.gender !== null) params.gender = this.gender;
					if (this.ages !== null) params.ages = this.ages;
					if (this.skinType !== null) params.skinType = this.skinType;
					if (this.rating !== null) params.rating = this.rating;
					if (this.isEvaluation !== null)
						params.isEvaluation = this.isEvaluation;
					const { config, data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/product/${this.idProduct}/stats`,
						{ params }
					);
					this.lastApiUrl = config.url;
					this.userTotal = data.userTotal;
					const limit = this.$route.query.limit;
					this.limit = limit || limit === 0 ? Number(limit) : null;
					this.statsData = data;
				} catch (err) {
					console.error(err);
					alert('통계 데이터를 불러오는 실패했습니다.');
				}
			},
			async setFilter(query) {
				this.gender = query.gender ? Number(query.gender) : null;
				this.ages = query.ages ? Number(query.ages) : null;
				this.skinType = query.skinType ? Number(query.skinType) : null;
				this.rating = query.rating ? Number(query.rating) : null;
				this.isEvaluation = query.isEvaluation
					? Number(query.isEvaluation)
					: null;
				this.idProduct = query.idProduct
					? Number(query.idProduct)
					: null;
				this.brandId = query.brandId ? Number(query.brandId) : null;
				this.idInitial =
					query.idInitial || query.idInitial === 0
						? Number(query.idInitial)
						: null;
				this.searchKeyword = query.searchKeyword || null;
				this.limit = query.limit ? Number(query.limit) : null;
				if (query.idProduct && query.brandId) {
					this.$refs.SearchBrandInitial.idInitial = this.idInitial;
					this.$refs.SearchBrandInitial.searchKeyword =
						this.searchKeyword;
					if (this.idInitial || this.idInitial === 0) {
						await this.$refs.SearchBrandInitial.getBrandList();
					} else if (this.searchKeyword) {
						await this.$refs.SearchBrandInitial.getBrandListBySearch();
					}
					this.$refs.SearchBrandInitial.selectedBrandId = Number(
						query.brandId
					);
					this.getStats();
				} else {
					this.$refs.SearchBrandInitial.idInitial = 0;
					this.$refs.SearchBrandInitial.getBrandList();
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.review-word-stats__product-selector {
		width: 100%;
	}
</style>
